import { SidenavService } from 'src/app/services/sidenav.service';
import { Component, HostListener, OnInit } from '@angular/core';
import { ColorCode } from '../Company.enum';
import { CompanyService } from 'src/app/services/company.service'
import { Router } from '@angular/router';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';

@Component({
  standalone: false,
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.scss']
})
export class CompanyListComponent implements OnInit {
  openOptionDrawer: boolean;
  parkId = (localStorage.getItem('parkId')) ? localStorage.getItem('parkId') : null;
  buildings = []

  buildingName: boolean;
  tenantSts: boolean;
  buildingTitle: any = [];
  selectedBuidling: any = []
  tenantStatus: any = 'Active';
  tenantStat: any = [{ name: 'Active', checked: true, id: 1 }, { name: 'Inactive', checked: false, id: 2 }];
  companies: any[] = []
  newCompanies: any[] = []
  searchText: string = ''
  pageSize = 20
  page = 1
  totalCount: number = 0
  private _filteredCompanies: any[] = []
  displayCount
  isChecked: boolean = false
  selectedComp: any[] = []
  checkboxValue: boolean = false;
  compCount: number = 0
  isDeactiveButtton: boolean = false
  isActiveButton: boolean = true
  dotDropDownDetail: any
  companyAdd: any;

  @HostListener('click', ['$event'])
  captureClick(event) {
    this.dotDropDownDetail = undefined
    if (event.target.className !== 'drawer-container') {
      this.openOptionDrawer = false;
    }
  }


  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  enterName(field) {
    if (field == 'buildingName') {
      this.buildingName = !this.buildingName;
    }

    if (field == 'tenantSts') {
      this.tenantSts = !this.tenantSts;
    }
  }
  // setBuildingName(item){
  //   this.buildingTitle.push(item.parkBuildingName)
  //   this.selectedBuildings.push(item.parkBuildingId)
  //   console.log(this.buildingTitle)
  //   console.log(this.selectedBuildings)
  // }
  inputModelChange() { }

  setTenantStatus(item) {
    this.selectedComp = []
    this.selectDeselectCompany(false)
    this.tenantStatus = item.name
    this.isActiveButton = true
    this.isDeactiveButtton = false
    if (item.name == 'Inactive') {
      this.isActiveButton = false
      this.isDeactiveButtton = true;
    }
    console.log(this.isDeactiveButtton)
    console.log(this.isActiveButton)
    this.getCompanyListByBuilding();
  }

  constructor(
    private compService: CompanyService,
    private appStateSrv: AppStateProvider,
    private sideNavService: SidenavService,
    private router: Router,
    private rolebasedactionService: RolebasedactionService,
  ) {
    this.getBuilindList();
  }

  ngOnInit(): void {
    this.companyAdd = this.rolebasedactionService.checkUserRolePermissionExits('Company:Create');
    this.totalCount = 0;
    this.companies = [];
    this.newCompanies = [];
    this._filteredCompanies = [];
    this.searchText = '';
    const route = this.sideNavService.routingChunks({ name: 'Company' });
    this.appStateSrv.setSideNavState(route);
  }

  handlePageChange(event) {
    this.page = event;
    // console.log('pagination clicked');
    // // this.accessPoint = this.accessPoints.map(
    // //   (access: any, i: any) => ({ id: i + 1, ...access })).slice(
    // //     (this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    // this.checkIn = this.checkIns.slice(
    //   0,
    //   this.checkIns.length < 10
    //     ? this.checkIns.length
    //     : (this.page - 1) * this.pageSize + this.pageSize
    // );
  }

  /**
   * Fetches the list of companies by building based on the provided park ID and building ID array.
   * It also filters the companies based on their active status.
   * 
   * @async
   * @function getCompanyListByBuilding
   * @returns {Promise<void>} A promise that resolves when the company list is fetched and processed.
   * 
   * @throws Will log an error message to the console if the fetch operation fails.
   * 
   * @remarks
   * This method constructs a payload with the park ID, building ID array, and active status.
   * It then calls the `getCompaniesByBuilding` method of the `compService` to fetch the company list.
   * If the response is valid, it updates the component's company list, new company list, total count, and display count.
   * If the response is not valid or an error occurs, it resets the company list, new company list, and total count to empty or zero.
   */
  async getCompanyListByBuilding() {
    let payload = {
      parkId: this.parkId,
      buildingId: this.getBuildingIdArr(),
      isActive: (this.tenantStatus == 'Active') ? true : false
    };
    try {
      const res = await this.compService.getCompaniesByBuilding(payload).toPromise();
      if (res && res.isValid) {
        this.companies = res.list || [];
        this.newCompanies = res?.list || [];
        this.searchText = ''; // Reset search text when data changes
        this.updateFilteredCompanies();
        this.displayCount = Math.ceil(this.totalCount / this.pageSize);
      } else {
        this.companies = [];
        this.newCompanies = [];
        this.searchText = '';
        this._filteredCompanies = [];
        this.totalCount = 0;
        this.displayCount = 0;
      }
    } catch (error) {
      console.error('Error fetching company list:', error);
      this.companies = [];
      this.newCompanies = [];
      this.totalCount = 0;
    }
  }

  searchByText(event: any) {
    console.log(event);
    console.log(this.companies);
    this.searchText = event || '';
    this.updateFilteredCompanies();
  }

  updateFilteredCompanies(): void {
    if (!this.newCompanies || !Array.isArray(this.newCompanies)) {
      this._filteredCompanies = [];
      this.totalCount = 0;
      return;
    }
    if (!this.searchText || this.searchText === '') {
      this._filteredCompanies = this.newCompanies;
      this.totalCount = this.newCompanies.length;
      return;
    }
    const searchLower = this.searchText.toLowerCase();
    this._filteredCompanies = this.newCompanies.filter((item: any) => {
      if (!item) return false;
      const tenantName = item.tenantName || '';
      return tenantName.toLowerCase().includes(searchLower);
    });
    this.totalCount = this._filteredCompanies.length;
  }

  getFilteredCompanies(): any[] {
    return this._filteredCompanies;
  }

  getBuilindList() {
    this.compService.getBuildingByParkId(this.parkId).subscribe(res => {
      console.log(res);
      if (res.isValid) {
        // this.buildings = res.list
        this.buildings = res.list.map(res => {
          res.checked = false
          return res
        });
        this.buildings.unshift({ parkBuildingName: 'All', parkBuildingId: 'All', checked: false });
        this.setBuildingName({ parkBuildingName: 'All', parkBuildingId: 'All', checked: false });
        this.getCompanyListByBuilding();
      }
    });
  }

  setBuildingName(item, event = '') {
    let AllChecked;
    if (this.buildings[0].checked == true) {
      console.log("isnide thiskk ");
      this.selectedBuidling = [];
      this.buildingTitle = []
      this.buildings = this.buildings.map(res => {
        res.checked = false;
        return res;
      })
    }
    this.buildingTitle.push(item)
    console.log(this.buildingTitle)
    if (item.parkBuildingId == 'All') {
      this.selectedBuidling = []
      AllChecked = !item.checked
      this.buildingTitle = (AllChecked) ? this.removeAll() : [];
    }
    this.buildings = this.buildings.map(res => {
      if (item.parkBuildingId == 'All') {
        res.checked = AllChecked;
      } else if (item.parkBuildingId == res.parkBuildingId) {
        res.checked = !res.checked;
      }
      return res;
    })
    this.getCheckedData(event);
    console.log(this.selectedBuidling);
  }

  getCheckedData(event = '') {
    this.selectedBuidling = []
    let resultArr = this.buildings.slice(1);
    let filteredArr = resultArr.filter(res => {
      if (res.checked) {
        return res
      }
    })
    this.selectedBuidling = filteredArr.map(res => {
      return res.parkBuildingName
    });
    this.buildings[0].checked = ((this.buildings.length - 1) === this.selectedBuidling.length) ? true : false
    if (event == 'click') {
      this.getCompanyListByBuilding();
    }
    console.log(this.selectedBuidling);
  }

  removeAll($filter = '') {
    if ($filter == 'name') {
      let resultArr = this.buildings.slice(1);
      return resultArr.map(res => {
        return res.parkBuildingName
      });
    } else {
      return this.buildings.slice(1);
    }
  }

  getBuildingIdArr() {
    let finalArr = []
    this.selectedBuidling.forEach((element, i) => {
      this.buildings.forEach(element1 => {
        if (element1.parkBuildingName == element) {
          finalArr.push(element1.parkBuildingId);
        }
      });
    });
    return finalArr;
  }



  getSelectedCompany(event) {
    console.log(event);
    console.log(this.compCount);
    if (event.checked) {
      this.selectedComp.push(event.id);
    } else {
      var index = this.selectedComp.indexOf(event.id);
      this.selectedComp.splice(index, 1);
    }
    this.isChecked = ((this.pageSize == this.selectedComp.length || this.companies.length == this.selectedComp.length)) ? true : false
    console.log(this.selectedComp);
    // this.checkSelectedCompForDropdown();
  }

  selectDeselectCompany(Status = undefined) {
    this.isChecked = (Status !== undefined) ? Status : !this.isChecked
    this.checkboxValue = this.isChecked
    this.selectedComp = [];
    if (this.isChecked) {
      this.companies.filter(res => {
        console.log(res);
        if (!res.isTenantExpired) {
          this.selectedComp.push(res.tenantId);
        }
      });
    }
    // this.checkSelectedCompForDropdown();
  }

  // checkSelectedCompForDropdown() {
  //   // let checkActive = false, checkInactive =false;
  //   // this.isActiveButton =true;
  //   // this.isDeactiveButtton = true;
  //   // console.log("came here");
  //   // this.selectedComp.forEach((res,i) => {
  //   //   console.log(res);
  //   //   this.companies.forEach(element => {
  //   //     if(element.tenantId == res && element.isActive == true) {
  //   //       this.isActiveButton = true;
  //   //       checkActive = true;
  //   //     }
  //   //     if(element.userId == res && element.isActive == false) {
  //   //       this.isDeactiveButtton = true;
  //   //       checkInactive = true;
  //   //     }
  //   //   });
  //   //   if(i == (this.selectedComp.length -1) && !checkActive) {
  //   //     this.isActiveButton = false;
  //   //   }
  //   //   if(i == (this.selectedComp.length -1) && !checkInactive) {
  //   //     this.isDeactiveButtton = false;
  //   //   }
  //   // });
  // }

  redirectToTenantEdit(event) {
    this.router.navigate(['/company/edit-company', event]);
  }

  changeCompanyStatus() {
    console.log(this.selectedComp);
    this.compService.changeCompanyStatus(this.selectedComp).subscribe(res => {
      console.log(res)
      if (res.isValid) {
        this.getCompanyListByBuilding();
      }
    });
  }

  //company active or inactive
  updateComp(event) {
    console.log(event);
    // if(event.type == 'active') {

    // } else {

    // }
    //call status change api
    this.compService.changeCompanyStatus([event.id]).subscribe(res => {
      console.log(res)
      if (res.isValid) {
        this.getCompanyListByBuilding();
      }
    });
  }

}
